const baseApiUrl = () => {
    // return "http://127.0.0.1:8000/api/"; 
    return `${process.env.REACT_APP_SITELINK}api/`; 
    // return "http://ozchest-app-214.test/api/"; 
    // return "https://pakbettv-serverside.cdn.rooberp.com/api/"; 
 };
 
 export default baseApiUrl;